import axios from 'axios';

async function checkFiltersApplicable(params) {
  const resource = 'country-management/check-filter';

  try {
    const response = await axios.get(resource, { params });
    return response;
  } catch (error) {
    return error.message;
  }
}

export default checkFiltersApplicable;
